// imports
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import dayjs, { Dayjs } from 'dayjs';

// styles
import styles from './DatePicker.module.scss';

interface MultiLivestreamDatePickerProps {
  onChange: (date: string) => void;
  now: Dayjs;
  scheduleDate: string;
}

const MultiLivestreamDatePicker = (props: MultiLivestreamDatePickerProps) => {
  const { now, onChange, scheduleDate } = props;

  // We've been told schedule date is reliable up to 14 days in the future,
  // but we'll display this number of days in the dropdown
  const NUMBER_OF_DAYS_IN_FUTURE_TO_SHOW = 5;

  const options = [];
  const today = dayjs(now);
  options.push(
    <option value={today.format('YYYY-MM-DD')} key="datepicker-option-0">
      {today.format('ddd M/D')}
    </option>
  )

  for (let i = 1; i <= NUMBER_OF_DAYS_IN_FUTURE_TO_SHOW; i++) {
    const day = dayjs(now).add(i, 'day');
    options.push(
      <option
        value={day.format('YYYY-MM-DD')}
        key={`datepicker-option-${i}`}
      >
        {day.format('ddd M/D')}
      </option>
    )
  };

  const handleOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedDate = event.target.value;
    onChange(selectedDate);
  };

  return (
    <select
      className={styles.multi_livestream__schedule__datepicker}
      onChange={handleOnChange}
      aria-label="Select date"
      defaultValue={scheduleDate}
      name="date"
    data-sentry-component="MultiLivestreamDatePicker" data-sentry-source-file="DatePicker.tsx">
      {options}
    </select>
  );
};

export default MultiLivestreamDatePicker;
